// import React, { Fragment, FunctionComponent } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPiggyBank } from "@fortawesome/free-solid-svg-icons";
// import { Graphics } from "../styles/agency-income-metrics-styles";

// const Zero: FunctionComponent<unknown> = () => (
//   <Fragment>
//     <Graphics donate>
//       <FontAwesomeIcon icon={faPiggyBank} />
//     </Graphics>
//   </Fragment>
// );

// export default Zero;
